import { MiscScreen } from '@bonanza-social/navigation';

function CommunityJackpotRulesScreen() {
  return <MiscScreen path="/communityJackpotRules" />;
}

export default CommunityJackpotRulesScreen;
